module.exports = __webpack_public_path__ + "img/hc_btn.0021851c.png";